import { AppEventCard } from 'components/AppDashboard/AppEventCard/AppEventCard.component'
import { ChevronDownIcon } from '@heroicons/react/outline'
import history from 'utils/history'
import { useEffect, useState } from 'react'
import { IUpcomingEvent } from 'types'
import React from 'react'
import { getRoleFromPath } from 'utils/helper'
import { useTenantId } from 'utils/useTenantId'

export interface IAppDashboardUpcomingEventsItemsProps {
  events: IUpcomingEvent[]
  showInternalMeetingsOnly?: boolean
}
export const AppDashboardUpcomingEventsItems: React.FC<IAppDashboardUpcomingEventsItemsProps> = ({
  events,
  showInternalMeetingsOnly,
}) => {
  const tenantId = useTenantId()
  const [showAll, setShowAll] = useState(false)

  useEffect(() => {
    setShowAll(false)
  }, [showInternalMeetingsOnly])

  const displayedEvents = showAll ? events : events.slice(0, 2)
  const hasMoreEvents = events.length > 2
  return (
    <>
      {displayedEvents.map((event, idx) => {
        return (
          <div
            key={`event-card-${idx + 1}`}
            className="flex items-stretch border border-app-grey-30 shadow-sm cursor-pointer rounded-lg"
          >
            <AppEventCard
              description={event.description}
              startDate={event.date}
              endDate={event.endDate ?? ''}
              eventId={event.eventId}
              eventType={event.eventType}
              businessName={event.businessName}
              businessLogo={event.businessLogo}
              className="flex-grow !rounded-none !border-none !bg-white !rounded-l-lg !w-[80%]"
            />
            <div
              className="flex-grow bg-app-primary-70 text-white flex items-center justify-center rounded-r-lg font-inter font-medium text-sm w-[20%]"
              onClick={() =>
                history.push(`/${getRoleFromPath()}/${tenantId}/calendar?eventId=${event.eventId}`)
              }
            >
              View
            </div>
          </div>
        )
      })}
      {hasMoreEvents && !showAll && (
        <button
          onClick={() => setShowAll(true)}
          className="py-2 px-4  flex items-center gap-2 border border-app-grey-30 rounded-lg"
        >
          <span className="text-app-black-100 font-normal text-sm">Show More</span>{' '}
          <ChevronDownIcon className="w-4 h-4 text-app-black-100" />
        </button>
      )}
    </>
  )
}
